import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Modal from './Modal';

export default function Portal(props) {
  const rootSelector =
    typeof document !== 'undefined'
      ? document.getElementById('modal-root')
      : null;
  const containerRef = useRef(null);
  if (containerRef.current === null && typeof document !== 'undefined') {
    containerRef.current = document.createElement('div');
  }

  useEffect(() => {
    const root = rootSelector;
    const el = containerRef.current;
    if (!root || !el) {
      return;
    }
    root.appendChild(el);
    return () => {
      root.removeChild(el);
    };
  }, [rootSelector]);

  if (!containerRef.current || !rootSelector) {
    return null;
  }

  return ReactDOM.createPortal(<Modal {...props} />, containerRef.current);
}
